module.exports = __webpack_public_path__ + "img/101.97c9e65a.jpg";